<template>
  <div>
    <div v-if="campList.length > 0">
      <div class="list-category h3-style mobile-h3 d-lg-none">正取</div>
      <template v-for="data in campList" :key="data.name">
        <div
          class="col-lg-10 d-flex list-row text-lg-center"
          v-if="data.status === 1"
        >
          <div class="name">{{ data.name }}</div>
          <div
            class="
              d-flex
              flex-column flex-md-row
              justify-content-around
              flex-grow-1
            "
          >
            <div class="school">{{ data.school }}</div>
            <div class="dept">{{ data.dept }}</div>
          </div>
          <div class="status d-none d-lg-block">
            {{ data.status === 1 ? "正取" : "備取" }}
          </div>
        </div>
      </template>
      <div class="mt-lg-4"></div>
      <div class="list-category h3-style mobile-h3 d-lg-none">備取</div>
      <template v-for="data in campList" :key="data.name">
        <div
          class="col-lg-10 d-flex list-row text-lg-center"
          v-if="data.status === 2"
        >
          <div class="name">{{ data.name }}</div>
          <div
            class="
              d-flex
              flex-column flex-md-row
              justify-content-around
              flex-grow-1
            "
          >
            <div class="school">{{ data.school }}</div>
            <div class="dept">{{ data.dept }}</div>
          </div>
          <div class="status d-none d-lg-block">
            {{ data.status === 1 ? "正取" : "備取" }}
          </div>
        </div>
      </template>
    </div>
    <div v-else class="col-lg-9 text-center mb-5 h4-style">
      ～名單尚未公布～
    </div>
  </div>
</template>

<script>
import { getDomesticList } from '@/api/camp-list';

export default {
  name: 'Camp',
  data() {
    return {
      campList: [],
    };
  },
  methods: {
    getList() {
      const filter = { where: { group: parseInt(this.$route.params.groupId[5], 10), stage: 1 }, order: 'stage asc, sort asc' };
      getDomesticList({ filter }).then((response) => {
        this.campList = response;
      });
    },
  },
  created() {
    this.getList();
  },
  watch: {
    '$route.params.groupId': function () {
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'groupId')) this.getList();
    },
  },
};
</script>

<style lang="stylus" scoped>
.list-category
  padding: 30px;
  text-align: center;

.list-row
  padding: 8px;

  // width: 100%;
  +.list-row
    border-top: 1px solid $monoc4;

  .name
    width: 88px;

  .school, .dept
    min-width: calc(50% - 80px);

  .status
    width: 72px;

@media screen and (max-width: 767.5px)
  .list-row .name
    font-weight: bold;
    align-self: center;
    text-align: center;
    width: 120px;

ul.lv1 > li:nth-child(1) > a
  opacity: 1;
</style>
